import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const APP_API_CONNECT = process.env.REACT_APP_API_CONNECT;

export const searchApi = createApi({
  reducerPath: "searchApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${APP_API_CONNECT}/`,
  }),

  tagTypes: ["Search"],
  refetchOnMountOrArgChange: 1,
  keepUnusedDataFor: 86400000,
  endpoints: (builder) => ({
    getSearchQuery: builder.query({
      query: (data) => {
        return {
          url: `api/products/search/${data.query}?page=${data.page}&size=${data.size}${data.search_id}${data.searchCountry}&socketId=${data.socketId}&cartToken=${data.cartToken}`,
          method: "GET",
          headers: {
            "X-Country-Code": data.countryCode,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 86400000,
      providesTags: ["Search"],
    }),

    searchProductsList: builder.query({
      query: (data) => {
        return {
          url: `api/products/search/list/query?page=${data.page}&size=${data.size}${data.query ? `&search=${data.query}` : ""}${data.searchCountry}`,
          method: "GET",
          headers: {
            "X-Country-Code": data.countryCode,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 86400000,
      providesTags: ["Search"],
    }),
  }),
});

export const { useGetSearchQueryQuery, useSearchProductsListQuery } = searchApi;
